// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_duration from "../../google_wkt/gen/google_protobuf_duration.js";
import * as Ocaml_protoc_plugin from "../../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Google = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  656,
  6
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "ErrorInfo"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "RetryInfo"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "DebugInfo"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Violation"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "QuotaFailure"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Violation"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "PreconditionFailure"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "FieldViolation"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "BadRequest"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "RequestInfo"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "ResourceInfo"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Link"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Help"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "LocalizedMessage"
          ]
        ]
      },
      "Rpc"
    ]]
});

const Rpc = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  1282,
  8
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "ErrorInfo"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "RetryInfo"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "DebugInfo"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Violation"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "QuotaFailure"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Violation"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "PreconditionFailure"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "FieldViolation"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "BadRequest"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "RequestInfo"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "ResourceInfo"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Link"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Help"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "LocalizedMessage"
    ]
  ]
});

const ErrorInfo = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  1330,
  10
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const RetryInfo = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  1412,
  10
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const DebugInfo = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  1473,
  10
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const QuotaFailure = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  1580,
  10
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Violation"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const PreconditionFailure = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  1761,
  10
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Violation"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const BadRequest = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  1979,
  10
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "FieldViolation"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const RequestInfo = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  2192,
  10
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ResourceInfo = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  2269,
  10
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const Help = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  2380,
  10
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Link"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const LocalizedMessage = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  2507,
  10
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".google.rpc.ErrorInfo";
}

function make(reasonOpt, domainOpt, metadataOpt, param) {
  const reason = reasonOpt !== undefined ? reasonOpt : "";
  const domain = domainOpt !== undefined ? domainOpt : "";
  const metadata = metadataOpt !== undefined ? metadataOpt : /* [] */ 0;
  return {
    reason: reason,
    domain: domain,
    metadata: metadata
  };
}

const merge_reason = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "reason",
    "reason"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_domain = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "domain",
    "domain"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_metadata = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.map([
  [
    3,
    "metadata",
    "metadata"
  ],
  [
    Ocaml_protoc_plugin__Spec.string,
    Ocaml_protoc_plugin__Spec.basic([
      [
        2,
        "value",
        "value"
      ],
      Ocaml_protoc_plugin__Spec.string,
      ""
    ])
  ]
]));

function merge(t1, t2) {
  return {
    reason: Curry._2(merge_reason, t1.reason, t2.reason),
    domain: Curry._2(merge_domain, t1.domain, t2.domain),
    metadata: Curry._2(merge_metadata, t1.metadata, t2.metadata)
  };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "reason",
      "reason"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "domain",
      "domain"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.map([
    [
      3,
      "metadata",
      "metadata"
    ],
    [
      Ocaml_protoc_plugin__Spec.string,
      Ocaml_protoc_plugin__Spec.basic([
        [
          2,
          "value",
          "value"
        ],
        Ocaml_protoc_plugin__Spec.string,
        ""
      ])
    ]
  ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p(writer, param) {
  Curry._4(serialize, writer, param.reason, param.domain, param.metadata);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(reason, domain, metadata) {
  return {
    reason: reason,
    domain: domain,
    metadata: metadata
  };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.rpc.ErrorInfo", spec(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.reason, param.domain, param.metadata);
  };
}

function constructor$1(reason, domain, metadata) {
  return {
    reason: reason,
    domain: domain,
    metadata: metadata
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.rpc.ErrorInfo", spec(undefined), constructor$1);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ErrorInfo, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

function name$1(param) {
  return ".google.rpc.RetryInfo";
}

function make$1(retry_delay, param) {
  return {
    retry_delay: retry_delay
  };
}

const $$let = Google_wkt__Google_protobuf_duration.Google.Protobuf.Duration;

const merge_retry_delay = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "retry_delay",
    "retryDelay"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let.name,
    make: $$let.make,
    from_proto: $$let.from_proto,
    from_proto_exn: $$let.from_proto_exn,
    to_proto: $$let.to_proto,
    to_proto$p: $$let.to_proto$p,
    merge: $$let.merge,
    to_json: $$let.to_json,
    from_json_exn: $$let.from_json_exn,
    from_json: $$let.from_json
  })
]));

function merge$1(t1, t2) {
  return {
    retry_delay: Curry._2(merge_retry_delay, t1.retry_delay, t2.retry_delay)
  };
}

function spec$1(param) {
  const $$let = Google_wkt__Google_protobuf_duration.Google.Protobuf.Duration;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "retry_delay",
      "retryDelay"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
});

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.retry_delay);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(retry_delay) {
  return {
    retry_delay: retry_delay
  };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
});

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$1, writer);
  });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.rpc.RetryInfo", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.retry_delay);
  };
}

function constructor$3(retry_delay) {
  return {
    retry_delay: retry_delay
  };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.rpc.RetryInfo", spec$1(undefined), constructor$3);
});

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$1, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, RetryInfo, {
  make: make$1,
  to_proto: to_proto$1,
  from_proto: from_proto$1,
  to_json: to_json$1,
  from_json: from_json$1,
  name: name$1,
  merge: merge$1,
  to_proto$p: to_proto$p$1,
  from_proto_exn: from_proto_exn$1,
  from_json_exn: from_json_exn$1
});

function name$2(param) {
  return ".google.rpc.DebugInfo";
}

function make$2(stack_entriesOpt, detailOpt, param) {
  const stack_entries = stack_entriesOpt !== undefined ? stack_entriesOpt : /* [] */ 0;
  const detail = detailOpt !== undefined ? detailOpt : "";
  return {
    stack_entries: stack_entries,
    detail: detail
  };
}

const merge_stack_entries = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    1,
    "stack_entries",
    "stackEntries"
  ],
  Ocaml_protoc_plugin__Spec.string,
  Ocaml_protoc_plugin__Spec.not_packed
]));

const merge_detail = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "detail",
    "detail"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$2(t1, t2) {
  return {
    stack_entries: Curry._2(merge_stack_entries, t1.stack_entries, t2.stack_entries),
    detail: Curry._2(merge_detail, t1.detail, t2.detail)
  };
}

function spec$2(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      1,
      "stack_entries",
      "stackEntries"
    ],
    Ocaml_protoc_plugin__Spec.string,
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "detail",
      "detail"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
});

function to_proto$p$2(writer, param) {
  Curry._3(serialize$2, writer, param.stack_entries, param.detail);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(stack_entries, detail) {
  return {
    stack_entries: stack_entries,
    detail: detail
  };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
});

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$2, writer);
  });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.rpc.DebugInfo", spec$2(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.stack_entries, param.detail);
  };
}

function constructor$5(stack_entries, detail) {
  return {
    stack_entries: stack_entries,
    detail: detail
  };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.rpc.DebugInfo", spec$2(undefined), constructor$5);
});

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$2, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, DebugInfo, {
  make: make$2,
  to_proto: to_proto$2,
  from_proto: from_proto$2,
  to_json: to_json$2,
  from_json: from_json$2,
  name: name$2,
  merge: merge$2,
  to_proto$p: to_proto$p$2,
  from_proto_exn: from_proto_exn$2,
  from_json_exn: from_json_exn$2
});

const Violation = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  1620,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$3(param) {
  return ".google.rpc.QuotaFailure.Violation";
}

function make$3(subjectOpt, descriptionOpt, param) {
  const subject = subjectOpt !== undefined ? subjectOpt : "";
  const description = descriptionOpt !== undefined ? descriptionOpt : "";
  return {
    subject: subject,
    description: description
  };
}

const merge_subject = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "subject",
    "subject"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_description = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "description",
    "description"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$3(t1, t2) {
  return {
    subject: Curry._2(merge_subject, t1.subject, t2.subject),
    description: Curry._2(merge_description, t1.description, t2.description)
  };
}

function spec$3(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "subject",
      "subject"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "description",
      "description"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
});

function to_proto$p$3(writer, param) {
  Curry._3(serialize$3, writer, param.subject, param.description);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(subject, description) {
  return {
    subject: subject,
    description: description
  };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
});

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$3, writer);
  });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.rpc.QuotaFailure.Violation", spec$3(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.subject, param.description);
  };
}

function constructor$7(subject, description) {
  return {
    subject: subject,
    description: description
  };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.rpc.QuotaFailure.Violation", spec$3(undefined), constructor$7);
});

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$3, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Violation, {
  make: make$3,
  to_proto: to_proto$3,
  from_proto: from_proto$3,
  to_json: to_json$3,
  from_json: from_json$3,
  name: name$3,
  merge: merge$3,
  to_proto$p: to_proto$p$3,
  from_proto_exn: from_proto_exn$3,
  from_json_exn: from_json_exn$3
});

function name$4(param) {
  return ".google.rpc.QuotaFailure";
}

function make$4(violationsOpt, param) {
  const violations = violationsOpt !== undefined ? violationsOpt : /* [] */ 0;
  return {
    violations: violations
  };
}

const merge_violations = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    1,
    "violations",
    "violations"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: Violation.name,
    make: Violation.make,
    from_proto: Violation.from_proto,
    from_proto_exn: Violation.from_proto_exn,
    to_proto: Violation.to_proto,
    to_proto$p: Violation.to_proto$p,
    merge: Violation.merge,
    to_json: Violation.to_json,
    from_json_exn: Violation.from_json_exn,
    from_json: Violation.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$4(t1, t2) {
  return {
    violations: Curry._2(merge_violations, t1.violations, t2.violations)
  };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      1,
      "violations",
      "violations"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: Violation.name,
      make: Violation.make,
      from_proto: Violation.from_proto,
      from_proto_exn: Violation.from_proto_exn,
      to_proto: Violation.to_proto,
      to_proto$p: Violation.to_proto$p,
      merge: Violation.merge,
      to_json: Violation.to_json,
      from_json_exn: Violation.from_json_exn,
      from_json: Violation.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
});

function to_proto$p$4(writer, param) {
  Curry._2(serialize$4, writer, param.violations);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(violations) {
  return {
    violations: violations
  };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
});

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$4, writer);
  });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.rpc.QuotaFailure", spec$4(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.violations);
  };
}

function constructor$9(violations) {
  return {
    violations: violations
  };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.rpc.QuotaFailure", spec$4(undefined), constructor$9);
});

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$4, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Violation"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, QuotaFailure, {
  Violation: Violation,
  make: make$4,
  to_proto: to_proto$4,
  from_proto: from_proto$4,
  to_json: to_json$4,
  from_json: from_json$4,
  name: name$4,
  merge: merge$4,
  to_proto$p: to_proto$p$4,
  from_proto_exn: from_proto_exn$4,
  from_json_exn: from_json_exn$4
});

const Violation$1 = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  1801,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$5(param) {
  return ".google.rpc.PreconditionFailure.Violation";
}

function make$5(type$pOpt, subjectOpt, descriptionOpt, param) {
  const type$p = type$pOpt !== undefined ? type$pOpt : "";
  const subject = subjectOpt !== undefined ? subjectOpt : "";
  const description = descriptionOpt !== undefined ? descriptionOpt : "";
  return {
    "type'": type$p,
    subject: subject,
    description: description
  };
}

const merge_type$p = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "type",
    "type"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_subject$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "subject",
    "subject"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_description$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "description",
    "description"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$5(t1, t2) {
  return {
    "type'": Curry._2(merge_type$p, t1["type'"], t2["type'"]),
    subject: Curry._2(merge_subject$1, t1.subject, t2.subject),
    description: Curry._2(merge_description$1, t1.description, t2.description)
  };
}

function spec$5(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "type",
      "type"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "subject",
      "subject"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "description",
      "description"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
});

function to_proto$p$5(writer, param) {
  Curry._4(serialize$5, writer, param["type'"], param.subject, param.description);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(type$p, subject, description) {
  return {
    "type'": type$p,
    subject: subject,
    description: description
  };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
});

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$5, writer);
  });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.rpc.PreconditionFailure.Violation", spec$5(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param["type'"], param.subject, param.description);
  };
}

function constructor$11(type$p, subject, description) {
  return {
    "type'": type$p,
    subject: subject,
    description: description
  };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.rpc.PreconditionFailure.Violation", spec$5(undefined), constructor$11);
});

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$5, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Violation$1, {
  make: make$5,
  to_proto: to_proto$5,
  from_proto: from_proto$5,
  to_json: to_json$5,
  from_json: from_json$5,
  name: name$5,
  merge: merge$5,
  to_proto$p: to_proto$p$5,
  from_proto_exn: from_proto_exn$5,
  from_json_exn: from_json_exn$5
});

function name$6(param) {
  return ".google.rpc.PreconditionFailure";
}

function make$6(violationsOpt, param) {
  const violations = violationsOpt !== undefined ? violationsOpt : /* [] */ 0;
  return {
    violations: violations
  };
}

const merge_violations$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    1,
    "violations",
    "violations"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: Violation$1.name,
    make: Violation$1.make,
    from_proto: Violation$1.from_proto,
    from_proto_exn: Violation$1.from_proto_exn,
    to_proto: Violation$1.to_proto,
    to_proto$p: Violation$1.to_proto$p,
    merge: Violation$1.merge,
    to_json: Violation$1.to_json,
    from_json_exn: Violation$1.from_json_exn,
    from_json: Violation$1.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$6(t1, t2) {
  return {
    violations: Curry._2(merge_violations$1, t1.violations, t2.violations)
  };
}

function spec$6(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      1,
      "violations",
      "violations"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: Violation$1.name,
      make: Violation$1.make,
      from_proto: Violation$1.from_proto,
      from_proto_exn: Violation$1.from_proto_exn,
      to_proto: Violation$1.to_proto,
      to_proto$p: Violation$1.to_proto$p,
      merge: Violation$1.merge,
      to_json: Violation$1.to_json,
      from_json_exn: Violation$1.from_json_exn,
      from_json: Violation$1.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
});

function to_proto$p$6(writer, param) {
  Curry._2(serialize$6, writer, param.violations);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(violations) {
  return {
    violations: violations
  };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
});

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$6, writer);
  });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.rpc.PreconditionFailure", spec$6(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.violations);
  };
}

function constructor$13(violations) {
  return {
    violations: violations
  };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.rpc.PreconditionFailure", spec$6(undefined), constructor$13);
});

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$6, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Violation"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, PreconditionFailure, {
  Violation: Violation$1,
  make: make$6,
  to_proto: to_proto$6,
  from_proto: from_proto$6,
  to_json: to_json$6,
  from_json: from_json$6,
  name: name$6,
  merge: merge$6,
  to_proto$p: to_proto$p$6,
  from_proto_exn: from_proto_exn$6,
  from_json_exn: from_json_exn$6
});

const FieldViolation = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  2054,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$7(param) {
  return ".google.rpc.BadRequest.FieldViolation";
}

function make$7(fieldOpt, descriptionOpt, param) {
  const field = fieldOpt !== undefined ? fieldOpt : "";
  const description = descriptionOpt !== undefined ? descriptionOpt : "";
  return {
    field: field,
    description: description
  };
}

const merge_field = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "field",
    "field"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_description$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "description",
    "description"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$7(t1, t2) {
  return {
    field: Curry._2(merge_field, t1.field, t2.field),
    description: Curry._2(merge_description$2, t1.description, t2.description)
  };
}

function spec$7(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "field",
      "field"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "description",
      "description"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
});

function to_proto$p$7(writer, param) {
  Curry._3(serialize$7, writer, param.field, param.description);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$14(field, description) {
  return {
    field: field,
    description: description
  };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
});

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$7, writer);
  });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.rpc.BadRequest.FieldViolation", spec$7(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.field, param.description);
  };
}

function constructor$15(field, description) {
  return {
    field: field,
    description: description
  };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.rpc.BadRequest.FieldViolation", spec$7(undefined), constructor$15);
});

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$7, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, FieldViolation, {
  make: make$7,
  to_proto: to_proto$7,
  from_proto: from_proto$7,
  to_json: to_json$7,
  from_json: from_json$7,
  name: name$7,
  merge: merge$7,
  to_proto$p: to_proto$p$7,
  from_proto_exn: from_proto_exn$7,
  from_json_exn: from_json_exn$7
});

function name$8(param) {
  return ".google.rpc.BadRequest";
}

function make$8(field_violationsOpt, param) {
  const field_violations = field_violationsOpt !== undefined ? field_violationsOpt : /* [] */ 0;
  return {
    field_violations: field_violations
  };
}

const merge_field_violations = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    1,
    "field_violations",
    "fieldViolations"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: FieldViolation.name,
    make: FieldViolation.make,
    from_proto: FieldViolation.from_proto,
    from_proto_exn: FieldViolation.from_proto_exn,
    to_proto: FieldViolation.to_proto,
    to_proto$p: FieldViolation.to_proto$p,
    merge: FieldViolation.merge,
    to_json: FieldViolation.to_json,
    from_json_exn: FieldViolation.from_json_exn,
    from_json: FieldViolation.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$8(t1, t2) {
  return {
    field_violations: Curry._2(merge_field_violations, t1.field_violations, t2.field_violations)
  };
}

function spec$8(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      1,
      "field_violations",
      "fieldViolations"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: FieldViolation.name,
      make: FieldViolation.make,
      from_proto: FieldViolation.from_proto,
      from_proto_exn: FieldViolation.from_proto_exn,
      to_proto: FieldViolation.to_proto,
      to_proto$p: FieldViolation.to_proto$p,
      merge: FieldViolation.merge,
      to_json: FieldViolation.to_json,
      from_json_exn: FieldViolation.from_json_exn,
      from_json: FieldViolation.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$8(undefined));
});

function to_proto$p$8(writer, param) {
  Curry._2(serialize$8, writer, param.field_violations);
}

function to_proto$8(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$8(writer, t);
  return writer;
}

function constructor$16(field_violations) {
  return {
    field_violations: field_violations
  };
}

const from_proto_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$8(undefined), constructor$16);
});

function from_proto$8(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$8, writer);
  });
}

function to_json$8(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.rpc.BadRequest", spec$8(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.field_violations);
  };
}

function constructor$17(field_violations) {
  return {
    field_violations: field_violations
  };
}

const from_json_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.rpc.BadRequest", spec$8(undefined), constructor$17);
});

function from_json$8(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$8, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "FieldViolation"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, BadRequest, {
  FieldViolation: FieldViolation,
  make: make$8,
  to_proto: to_proto$8,
  from_proto: from_proto$8,
  to_json: to_json$8,
  from_json: from_json$8,
  name: name$8,
  merge: merge$8,
  to_proto$p: to_proto$p$8,
  from_proto_exn: from_proto_exn$8,
  from_json_exn: from_json_exn$8
});

function name$9(param) {
  return ".google.rpc.RequestInfo";
}

function make$9(request_idOpt, serving_dataOpt, param) {
  const request_id = request_idOpt !== undefined ? request_idOpt : "";
  const serving_data = serving_dataOpt !== undefined ? serving_dataOpt : "";
  return {
    request_id: request_id,
    serving_data: serving_data
  };
}

const merge_request_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "request_id",
    "requestId"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_serving_data = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "serving_data",
    "servingData"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$9(t1, t2) {
  return {
    request_id: Curry._2(merge_request_id, t1.request_id, t2.request_id),
    serving_data: Curry._2(merge_serving_data, t1.serving_data, t2.serving_data)
  };
}

function spec$9(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "request_id",
      "requestId"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "serving_data",
      "servingData"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$9(undefined));
});

function to_proto$p$9(writer, param) {
  Curry._3(serialize$9, writer, param.request_id, param.serving_data);
}

function to_proto$9(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$9(writer, t);
  return writer;
}

function constructor$18(request_id, serving_data) {
  return {
    request_id: request_id,
    serving_data: serving_data
  };
}

const from_proto_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$9(undefined), constructor$18);
});

function from_proto$9(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$9, writer);
  });
}

function to_json$9(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.rpc.RequestInfo", spec$9(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.request_id, param.serving_data);
  };
}

function constructor$19(request_id, serving_data) {
  return {
    request_id: request_id,
    serving_data: serving_data
  };
}

const from_json_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.rpc.RequestInfo", spec$9(undefined), constructor$19);
});

function from_json$9(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$9, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, RequestInfo, {
  make: make$9,
  to_proto: to_proto$9,
  from_proto: from_proto$9,
  to_json: to_json$9,
  from_json: from_json$9,
  name: name$9,
  merge: merge$9,
  to_proto$p: to_proto$p$9,
  from_proto_exn: from_proto_exn$9,
  from_json_exn: from_json_exn$9
});

function name$10(param) {
  return ".google.rpc.ResourceInfo";
}

function make$10(resource_typeOpt, resource_nameOpt, ownerOpt, descriptionOpt, param) {
  const resource_type = resource_typeOpt !== undefined ? resource_typeOpt : "";
  const resource_name = resource_nameOpt !== undefined ? resource_nameOpt : "";
  const owner = ownerOpt !== undefined ? ownerOpt : "";
  const description = descriptionOpt !== undefined ? descriptionOpt : "";
  return {
    resource_type: resource_type,
    resource_name: resource_name,
    owner: owner,
    description: description
  };
}

const merge_resource_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "resource_type",
    "resourceType"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_resource_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "resource_name",
    "resourceName"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_owner = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "owner",
    "owner"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_description$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "description",
    "description"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$10(t1, t2) {
  return {
    resource_type: Curry._2(merge_resource_type, t1.resource_type, t2.resource_type),
    resource_name: Curry._2(merge_resource_name, t1.resource_name, t2.resource_name),
    owner: Curry._2(merge_owner, t1.owner, t2.owner),
    description: Curry._2(merge_description$3, t1.description, t2.description)
  };
}

function spec$10(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "resource_type",
      "resourceType"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "resource_name",
      "resourceName"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "owner",
      "owner"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "description",
      "description"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil))));
}

const serialize$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$10(undefined));
});

function to_proto$p$10(writer, param) {
  Curry._5(serialize$10, writer, param.resource_type, param.resource_name, param.owner, param.description);
}

function to_proto$10(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$10(writer, t);
  return writer;
}

function constructor$20(resource_type, resource_name, owner, description) {
  return {
    resource_type: resource_type,
    resource_name: resource_name,
    owner: owner,
    description: description
  };
}

const from_proto_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$10(undefined), constructor$20);
});

function from_proto$10(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$10, writer);
  });
}

function to_json$10(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.rpc.ResourceInfo", spec$10(undefined))(options);
  return function (param) {
    return Curry._4(serialize, param.resource_type, param.resource_name, param.owner, param.description);
  };
}

function constructor$21(resource_type, resource_name, owner, description) {
  return {
    resource_type: resource_type,
    resource_name: resource_name,
    owner: owner,
    description: description
  };
}

const from_json_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.rpc.ResourceInfo", spec$10(undefined), constructor$21);
});

function from_json$10(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$10, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ResourceInfo, {
  make: make$10,
  to_proto: to_proto$10,
  from_proto: from_proto$10,
  to_json: to_json$10,
  from_json: from_json$10,
  name: name$10,
  merge: merge$10,
  to_proto$p: to_proto$p$10,
  from_proto_exn: from_proto_exn$10,
  from_json_exn: from_json_exn$10
});

const Link = Caml_module.init_mod([
  "proto/third_party/google_rpc/gen/google_rpc_error_details.ml",
  2412,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$11(param) {
  return ".google.rpc.Help.Link";
}

function make$11(descriptionOpt, urlOpt, param) {
  const description = descriptionOpt !== undefined ? descriptionOpt : "";
  const url = urlOpt !== undefined ? urlOpt : "";
  return {
    description: description,
    url: url
  };
}

const merge_description$4 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "description",
    "description"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_url = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "url",
    "url"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$11(t1, t2) {
  return {
    description: Curry._2(merge_description$4, t1.description, t2.description),
    url: Curry._2(merge_url, t1.url, t2.url)
  };
}

function spec$11(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "description",
      "description"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "url",
      "url"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$11 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$11(undefined));
});

function to_proto$p$11(writer, param) {
  Curry._3(serialize$11, writer, param.description, param.url);
}

function to_proto$11(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$11(writer, t);
  return writer;
}

function constructor$22(description, url) {
  return {
    description: description,
    url: url
  };
}

const from_proto_exn$11 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$11(undefined), constructor$22);
});

function from_proto$11(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$11, writer);
  });
}

function to_json$11(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.rpc.Help.Link", spec$11(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.description, param.url);
  };
}

function constructor$23(description, url) {
  return {
    description: description,
    url: url
  };
}

const from_json_exn$11 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.rpc.Help.Link", spec$11(undefined), constructor$23);
});

function from_json$11(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$11, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Link, {
  make: make$11,
  to_proto: to_proto$11,
  from_proto: from_proto$11,
  to_json: to_json$11,
  from_json: from_json$11,
  name: name$11,
  merge: merge$11,
  to_proto$p: to_proto$p$11,
  from_proto_exn: from_proto_exn$11,
  from_json_exn: from_json_exn$11
});

function name$12(param) {
  return ".google.rpc.Help";
}

function make$12(linksOpt, param) {
  const links = linksOpt !== undefined ? linksOpt : /* [] */ 0;
  return {
    links: links
  };
}

const merge_links = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    1,
    "links",
    "links"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: Link.name,
    make: Link.make,
    from_proto: Link.from_proto,
    from_proto_exn: Link.from_proto_exn,
    to_proto: Link.to_proto,
    to_proto$p: Link.to_proto$p,
    merge: Link.merge,
    to_json: Link.to_json,
    from_json_exn: Link.from_json_exn,
    from_json: Link.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$12(t1, t2) {
  return {
    links: Curry._2(merge_links, t1.links, t2.links)
  };
}

function spec$12(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      1,
      "links",
      "links"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: Link.name,
      make: Link.make,
      from_proto: Link.from_proto,
      from_proto_exn: Link.from_proto_exn,
      to_proto: Link.to_proto,
      to_proto$p: Link.to_proto$p,
      merge: Link.merge,
      to_json: Link.to_json,
      from_json_exn: Link.from_json_exn,
      from_json: Link.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$12 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$12(undefined));
});

function to_proto$p$12(writer, param) {
  Curry._2(serialize$12, writer, param.links);
}

function to_proto$12(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$12(writer, t);
  return writer;
}

function constructor$24(links) {
  return {
    links: links
  };
}

const from_proto_exn$12 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$12(undefined), constructor$24);
});

function from_proto$12(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$12, writer);
  });
}

function to_json$12(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.rpc.Help", spec$12(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.links);
  };
}

function constructor$25(links) {
  return {
    links: links
  };
}

const from_json_exn$12 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.rpc.Help", spec$12(undefined), constructor$25);
});

function from_json$12(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$12, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Link"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Help, {
  Link: Link,
  make: make$12,
  to_proto: to_proto$12,
  from_proto: from_proto$12,
  to_json: to_json$12,
  from_json: from_json$12,
  name: name$12,
  merge: merge$12,
  to_proto$p: to_proto$p$12,
  from_proto_exn: from_proto_exn$12,
  from_json_exn: from_json_exn$12
});

function name$13(param) {
  return ".google.rpc.LocalizedMessage";
}

function make$13(localeOpt, messageOpt, param) {
  const locale = localeOpt !== undefined ? localeOpt : "";
  const message = messageOpt !== undefined ? messageOpt : "";
  return {
    locale: locale,
    message: message
  };
}

const merge_locale = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "locale",
    "locale"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_message = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "message",
    "message"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$13(t1, t2) {
  return {
    locale: Curry._2(merge_locale, t1.locale, t2.locale),
    message: Curry._2(merge_message, t1.message, t2.message)
  };
}

function spec$13(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "locale",
      "locale"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "message",
      "message"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$13 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$13(undefined));
});

function to_proto$p$13(writer, param) {
  Curry._3(serialize$13, writer, param.locale, param.message);
}

function to_proto$13(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$13(writer, t);
  return writer;
}

function constructor$26(locale, message) {
  return {
    locale: locale,
    message: message
  };
}

const from_proto_exn$13 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$13(undefined), constructor$26);
});

function from_proto$13(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$13, writer);
  });
}

function to_json$13(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.rpc.LocalizedMessage", spec$13(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.locale, param.message);
  };
}

function constructor$27(locale, message) {
  return {
    locale: locale,
    message: message
  };
}

const from_json_exn$13 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.rpc.LocalizedMessage", spec$13(undefined), constructor$27);
});

function from_json$13(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$13, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, LocalizedMessage, {
  make: make$13,
  to_proto: to_proto$13,
  from_proto: from_proto$13,
  to_json: to_json$13,
  from_json: from_json$13,
  name: name$13,
  merge: merge$13,
  to_proto$p: to_proto$p$13,
  from_proto_exn: from_proto_exn$13,
  from_json_exn: from_json_exn$13
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "ErrorInfo"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "RetryInfo"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "DebugInfo"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Violation"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "QuotaFailure"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Violation"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "PreconditionFailure"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "FieldViolation"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "BadRequest"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "RequestInfo"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "ResourceInfo"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Link"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Help"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "LocalizedMessage"
    ]
  ]
}, Rpc, {
  ErrorInfo: ErrorInfo,
  RetryInfo: RetryInfo,
  DebugInfo: DebugInfo,
  QuotaFailure: QuotaFailure,
  PreconditionFailure: PreconditionFailure,
  BadRequest: BadRequest,
  RequestInfo: RequestInfo,
  ResourceInfo: ResourceInfo,
  Help: Help,
  LocalizedMessage: LocalizedMessage
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "ErrorInfo"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "RetryInfo"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "DebugInfo"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Violation"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "QuotaFailure"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Violation"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "PreconditionFailure"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "FieldViolation"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "BadRequest"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "RequestInfo"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "ResourceInfo"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Link"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Help"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "LocalizedMessage"
          ]
        ]
      },
      "Rpc"
    ]]
}, Google, {
  Rpc: Rpc
});

export {
  Imported$pmodules,
  Google,
}
/* Google Not a pure module */
